module.exports = __webpack_public_path__ + "img/txt_info1.77783b96.png";